//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import swal from 'sweetalert2'
import axios from 'axios'

export default {
  layout: 'default',
  middleware: 'guest',

  components: {

  },

  metaInfo () {
    return { title: 'Account Registration' }
  },

  data: () => ({
      form: new Form({
          name: '',
          email: '',
          password: '',
          password_confirmation: ''
      })
  }),

  mounted(){
      window.addEventListener('message', this.onMessage, false)

      if(this.$route.query.cb){
          this.callback = true
          this.callbackPath = this.$route.query.cb
      }

  },

  beforeDestroy () {
      window.removeEventListener('message', this.onMessage)
  },

  methods: {

      isError(name){
          return this.getError(name).length == 0 ? false: true
      },

      getError(name){
          return this.form.errors.has(name) ? this.form.errors.errors[name][0] : ''
      },

      onMessage (e) {
          if (e.origin !== window.origin || !e.data.token) {
            return
          }
          this.$store.dispatch('auth/saveToken', {
            token: e.data.token
          })

          this.handleNextRoute()
      },

      async register () {
          // Register the user.
          const { data } = await this.form.post('/api/auth/register')

          // Log in the user.
          const { data: { token } } = await this.form.post('/api/auth/login')

          // Save the token.
          this.$store.dispatch('auth/saveToken', { token })

          // Update the user.
          await this.$store.dispatch('auth/updateUser', { user: data })

          // Redirect home.
          this.handleNextRoute()
      },

      backToLoginPage(){
          let obj = { name: 'login' }

          if(this.callback)
          obj.query = { cb: this.callbackPath }

          this.$router.push(obj)
      },

      handleNextRoute(){
            if(this.callback){
                window.location = this.callbackPath
            }
            else {
                this.$router.push({ name: 'home'})
            }
      }

  }
}

/**
 * @param  {Object} options
 * @return {Window}
 */
function openWindow (url, title, options = {}) {
  if (typeof url === 'object') {
    options = url
    url = ''
  }
  options = { url, title, width: 600, height: 720, ...options }
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
  const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
  const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height
  options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
  options.top = ((height / 2) - (options.height / 2)) + dualScreenTop
  const optionsStr = Object.keys(options).reduce((acc, key) => {
    acc.push(`${key}=${options[key]}`)
    return acc
  }, []).join(',')
  const newWindow = window.open(url, title, optionsStr)
  if (window.focus) {
    newWindow.focus()
  }
  return newWindow
}

